import { Link } from 'react-router-dom';
import { CheckCircle, Home, ShoppingBag } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const OrderSuccess = () => {
  return (
    <div className="min-h-screen bg-stone-50 py-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card className="border-0 shadow-xl">
          <CardContent className="p-12 text-center">
            <div className="mb-6">
              <CheckCircle className="mx-auto h-24 w-24 text-green-600" />
            </div>
            
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Order Placed Successfully!
            </h1>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Thank you for your order! We have received your order details and will contact you shortly to confirm the delivery.
            </p>

            <div className="bg-stone-50 rounded-lg p-6 mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">What's Next?</h2>
              <ul className="text-left space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <CheckCircle className="text-green-600 flex-shrink-0 mt-1" size={20} />
                  <span>Our team will review your order details</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="text-green-600 flex-shrink-0 mt-1" size={20} />
                  <span>We will call you to confirm your order and delivery time</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="text-green-600 flex-shrink-0 mt-1" size={20} />
                  <span>Your fresh products will be delivered to your doorstep</span>
                </li>
              </ul>
            </div>

            <div className="border-t border-stone-200 pt-6 mb-8">
              <p className="text-sm text-gray-600 mb-2">Need help with your order?</p>
              <div className="flex justify-center gap-4 text-sm">
                <a href="tel:01270706065" className="text-red-600 hover:text-red-700 font-medium">
                  📞 01270706065
                </a>
                <span className="text-gray-400">|</span>
                <a href="mailto:elitemeatfarms@gmail.com" className="text-red-600 hover:text-red-700 font-medium">
                  ✉️ elitemeatfarms@gmail.com
                </a>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild size="lg" className="bg-red-600 hover:bg-red-700 text-white">
                <Link to="/">
                  <Home className="mr-2" size={20} />
                  Back to Home
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="border-red-600 text-red-600 hover:bg-red-50">
                <Link to="/products">
                  <ShoppingBag className="mr-2" size={20} />
                  Continue Shopping
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default OrderSuccess;
